module.exports = __webpack_public_path__ + "media/components/lesson2/statics/sendMessage-44f3fda2311cb20994ded1222092a52f.png";